import { render, staticRenderFns } from "./InstantPrintOrdersDetails.vue?vue&type=template&id=14984d51&"
import script from "./InstantPrintOrdersDetails.vue?vue&type=script&lang=js&"
export * from "./InstantPrintOrdersDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports